import React from 'react';
import { Award, Briefcase, Mic2, Users, Laugh } from 'lucide-react';

const About = ({ bioData }) => {
  return (
    <section id="about" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-20 right-0 w-64 h-64 bg-pink/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-burgundy/10 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Bio text */}
          <div>
            <div className="inline-block mb-4">
              <Laugh className="w-12 h-12 text-burgundy" strokeWidth={1.5} />
            </div>
            <h2 className="text-4xl md:text-5xl font-playfair font-bold text-burgundy mb-6">
              About Me
            </h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                {bioData.bio}
              </p>
            </div>

            {/* Social links */}
            <div className="flex flex-wrap gap-4 mt-8">
              <a
                href={bioData.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-500 text-white rounded-full font-medium hover:scale-105 transition-transform duration-300 shadow-lg hover:shadow-xl"
              >
                Follow on Instagram
              </a>
              <a
                href={bioData.tiktokUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-black text-white rounded-full font-medium hover:scale-105 transition-transform duration-300 shadow-lg hover:shadow-xl"
              >
                Follow on TikTok
              </a>
              <a
                href={bioData.linkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-burgundy text-white rounded-full font-medium hover:scale-105 transition-transform duration-300 shadow-lg hover:shadow-xl"
              >
                LinkedIn
              </a>
            </div>
          </div>

          {/* Right: Credentials cards */}
          <div className="space-y-4">
            <div className="bg-gradient-to-br from-pink/30 to-pink/10 p-6 rounded-2xl border-2 border-burgundy/20 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-gradient-to-br from-burgundy to-bordeaux rounded-full shadow-lg">
                  <Mic2 className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Comedy Venues</h3>
                  <ul className="space-y-1 text-gray-600">
                    <li>• 2 Big Openings at The Comedy Store</li>
                    <li>• Leicester Square Theatre</li>
                    <li>• Banana Cabaret</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-burgundy/10 to-burgundy/5 p-6 rounded-2xl border-2 border-burgundy/20 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-gradient-to-br from-burgundy to-bordeaux rounded-full shadow-lg">
                  <Briefcase className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Corporate Background</h3>
                  <ul className="space-y-1 text-gray-600">
                    <li>• Marketing Tech Lead @ Smartsheet</li>
                    <li>• Meta, Google, Adobe experience</li>
                    <li>• 12+ years in tech & marketing</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink/20 to-white p-6 rounded-2xl border-2 border-burgundy/20 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-gradient-to-br from-burgundy to-pink rounded-full shadow-lg">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Multilingual Entertainer</h3>
                  <p className="text-gray-600">
                    Running comedy nights in both English and Italian, plus pub quiz hosting
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
